import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { registerWebMcpTools } from "./lib/webmcp";

const root = document.getElementById("root")!;

if (root.hasChildNodes()) {
  hydrateRoot(root, <App />);
} else {
  createRoot(root).render(<App />);
}

const unregisterWebMcpTools = registerWebMcpTools();

if (import.meta.hot) {
  import.meta.hot.dispose(unregisterWebMcpTools);
}
